import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { OFFER_ANCHOR, PRODUCT } from '../data/constants';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const showTimer = window.setTimeout(() => setVisible(true), 4000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(i => (i + 1) % buyers.length);
        setVisible(true);
      }, 700);
    }, 11000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearInterval(cycle);
      window.clearTimeout(timeout);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  const offset = reduceMotion ? 0 : -24;
  return <AnimatePresence data-id="element-147" data-mp="163wcgqrtry1s">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: offset,
      scale: reduceMotion ? 1 : 0.97
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: offset,
      scale: reduceMotion ? 1 : 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2.5 left-2.5 z-50 w-[250px] max-w-[calc(100vw-20px)] sm:bottom-5 sm:left-5 sm:w-[290px]" role="status" aria-live="polite" data-id="element-148" data-mp="115uy2j5cgmwn">
          <div className="relative rounded-lg border-[3px] border-forest bg-gold p-2.5 pr-7 shadow-xl ring-2 ring-leaf" data-id="element-149" data-mp="x5u7k04z0l98">
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-1 top-1 rounded p-1 text-forest transition-colors duration-150 ease-out hover:text-white" data-id="element-150" data-mp="s56kfpjv4oka">
              <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-151" data-mp="2apcpouelorfa" />
            </button>
            <a href={OFFER_ANCHOR} className="flex items-start gap-2" data-id="element-152" data-mp="2fn4tomsis3zu">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-forest" strokeWidth={2.5} aria-hidden="true" data-id="element-153" data-mp="2fphauxqgeabu" />
              <div className="min-w-0" data-id="element-154" data-mp="2pl2et1f31ko8">
                <p className="font-display text-sm font-extrabold leading-tight text-forest" data-id="element-155" data-mp="1rybr47he6xw9">
                  {buyer.name} {buyer.flag} just purchased
                </p>
                <p className="mt-0.5 truncate font-display text-[11px] font-bold uppercase tracking-wide text-forest" data-id="element-156" data-mp="1wutup40zkq70">
                  {PRODUCT}
                </p>
                <p className="mt-0.5 text-[11px] font-semibold text-forest" data-id="element-157" data-mp="26oj2y4cw9inz">
                  {buyer.city}, {buyer.country} · a few minutes ago
                </p>
              </div>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}